import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import httpService from "../../../services/httpServices/httpServices";
import StateSiteUserPublisher from "./StateSiteUserPublisher";
import { Link } from "react-router-dom";

export default function AddSite() {
  const [allSiteUserAdvertiserConfirm, setAllSiteUserAdvertiserConfirm] =
    useState([]);
  const history = useHistory();
  useEffect(() => {
    getAllSiteUserAdvertiser();
  }, []);

  const getAllSiteUserAdvertiser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allSiteUserAdvertiser = await sendRequestGetAllSiteUserAdvertiser();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allSiteUserAdvertiser) {
      return;
    }

    const userAllSitePublisherUrls = await getUserAllSitePublisherUrls();

    allSiteUserAdvertiser = allSiteUserAdvertiser.filter(
      (siteUserAdvertiser) => {
        if (userAllSitePublisherUrls.includes(siteUserAdvertiser.site_url)) {
          return false;
        }
        return siteUserAdvertiser;
      }
    );

    setAllSiteUserAdvertiserConfirm(
      filterAllSiteUserAdvertiserConfirm(allSiteUserAdvertiser)
    );
  };

  const getUserAllSitePublisherUrls = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allSiteUserPublisher = await sendRequestGetAllSiteUserPublisher();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allSiteUserPublisher) {
      return;
    }
    return allSiteUserPublisher.map((siteUserPublisher) => {
      return siteUserPublisher.url;
    });
  };

  const sendRequestGetAllSiteUserPublisher = async () => {
    const headersRequest = getHeaderRequest();
    let allSiteUserAdvertiser;
    try {
      allSiteUserAdvertiser = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/publisher/site",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allSiteUserAdvertiser.data.data;
  };

  const filterAllSiteUserAdvertiserConfirm = (allSiteUserAdvertiser) => {
    return allSiteUserAdvertiser.filter((item) => {
      if (
        item.state != StateSiteUserPublisher.statusSiteUserPublisher.CONFIRM
      ) {
        return false;
      }
      if (!item.site_url.includes("https://")) {
        return false;
      }

      return item;
    });
  };

  const sendRequestGetAllSiteUserAdvertiser = async () => {
    const headersRequest = getHeaderRequest();
    let allSiteUserAdvertiser;
    try {
      allSiteUserAdvertiser = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/site-user-advertiser",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allSiteUserAdvertiser.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateDoNotHaveSiteUserAdvertiserConfirm = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img
            className="img-fluid"
            src="/assets/img/do-not-have-advertiser.svg"
          />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p>
            {" "}
            شما در حال حاضر هیچ سایت تبلیغ دهنده فعال و دارای گواهینامه ssl
            ندارید :(
          </p>
        </div>
      </div>
    );
  };

  const addUserSitePublisher = async (userSitePublisherID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultSendRequestAddUserSitePublisher =
      await sendRequestAddUserSitePublisher(userSitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddUserSitePublisher) {
      return;
    }

    history.push("/site/all");
  };

  const sendRequestAddUserSitePublisher = async (userSitePublisherID) => {
    const headersRequest = getHeaderRequest();

    try {
      await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/publisher/site/add/" +
          userSitePublisherID,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateHtmlTagSiteUserAdvertiserConfirm = () => {
    return (
      <>
        <h4>سایت های تبلیغ دهنده فعال شما</h4>
        <div className="container-fluid pt-2">
          {allSiteUserAdvertiserConfirm.map((siteUserAdvertiserConfirm) => {
            return (
              <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title text-center">
                      <a
                        href={siteUserAdvertiserConfirm.site_url}
                        target="_blank"
                      >
                        {siteUserAdvertiserConfirm.site_url}
                      </a>
                    </h5>
                    <div className="card-text text-center pt-2">
                      <button
                        className="btn btn-success"
                        onClick={async (e) => {
                          e.preventDefault();
                          await addUserSitePublisher(
                            siteUserAdvertiserConfirm.id
                          );
                        }}
                      >
                        انتخاب به عنوان نمایش دهنده هایلات
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن سایت ها نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link className="btn btn-primary" to="/site/all">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div className="alert alert-warning ">
                <p>
                  <i className="fa fa-info pl-2"></i>شروط اضافه کردن سایت نمایش
                  دهنده :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p>
                      سایت شما باید جز سایت های تبلیغ دهنده و در وضعیت تایید شده
                      باشد.
                    </p>
                  </li>
                  <li>
                    <p>سایت شما باید Responsive باشد.</p>
                  </li>
                  <li>
                    <p> گواهینامه ssl باید در سایت شما فعال باشد.</p>
                  </li>
                </ul>
              </div>
              <div>
                {allSiteUserAdvertiserConfirm.length == 0
                  ? generateDoNotHaveSiteUserAdvertiserConfirm()
                  : generateHtmlTagSiteUserAdvertiserConfirm()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
